import { render } from "./Card.vue?vue&type=template&id=1b7fdd95&scoped=true"
import script from "./Card.vue?vue&type=script&lang=js"
export * from "./Card.vue?vue&type=script&lang=js"

import "./Card.vue?vue&type=style&index=0&id=1b7fdd95&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/solution/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b7fdd95"]])

export default __exports__